import AppLayout from '../../../../../component/appLayout';
import TaskDetail from '../taskDetail';
import { Group } from './styles';

const TaskDetailPage: React.FC = () => {
  return (
    <>
      <AppLayout isNewDocPage={true}>
        <Group>
          <TaskDetail />
        </Group>
      </AppLayout>
    </>
  );
};

export default TaskDetailPage;
